import React, { useState } from 'react';

import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import candyDay1 from './assets/images/expect/candy/day1/A1.jpg';
import candyDay2 from './assets/images/expect/candy/day1/B1.jpg';
import candyDay3 from './assets/images/expect/candy/day1/C1.jpg';
import candyDay4 from './assets/images/expect/candy/day1/D1.jpg';
import candyDay5 from './assets/images/expect/candy/day1/E1.jpg';
import candyDay6 from './assets/images/expect/candy/day1/F1.jpg';
import candyDay7 from './assets/images/expect/candy/day1/G1.jpg';

const photos1 = [
    { src: candyDay1, width: 157, height: 210 }
];

const photos2 = [
    { src: candyDay1 },
    { src: candyDay2 },
    { src: candyDay3 },
    { src: candyDay4 },
    { src: candyDay5 },
    { src: candyDay6 },
    { src: candyDay7 }
];

const Candyd1 = () => {
    const [index, setIndex] = useState(-1);
    return (
        <div className="litter-gallery">
            <PhotoAlbum photos={photos1} layout="rows" targetRowHeight={150} onClick={({ index }) => setIndex(index)} />
            <Lightbox
                slides={photos2}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />
        </div>
    )
}

export default Candyd1;
